
import { defineComponent, computed, ref } from '@vue/composition-api';
import AffirmPackagePrice from '~/components/v2/pdps/AffirmPackagePrice.vue';
import { useAffirm } from '~/composables/useAffirm';

export default defineComponent({
  name: 'AffirmSection',
  components: {
    AffirmPackagePrice,
  },
  setup() {
    // @ts-ignore
    const { $store } = useNuxtApp();
    const packageSelected = computed(() => $store.getters.packageSelected);
    const price = computed(() => packageSelected.value?.price || 0);
    const { reloadAffirmForPriceUpdate } = useAffirm();
    // TODO: use global total
    const affirmButton = ref<HTMLElement | null>(null);
    reloadAffirmForPriceUpdate({ price, elementRef: affirmButton });

    return {
      price,
      affirmButton,
    };
  },
});
